<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.purchases.retrieveLoader || $store.state.generals.retrieveLoader">
      <v-boilerplate type="card-heading, image, actions" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-card-text class="px-0 py-0 background">
          <v-row align="center" justify="end">
            <v-col cols="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title class="text-right mr-2 text--secondary font-weight-medium">Documento</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-select v-model="$v.retention.document.$model" :error="$v.retention.document.$error" :items="documentsList" readonly single-line :v-ripple="false" item-text="name" item-value="id" hide-details dense height="30" outlined background-color="white" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="mt-3">
                  <v-list-item-title class="text-right mr-2 text--secondary font-weight-medium">Fecha</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-menu v-model="menu" :close-on-content-click="false" offset-y transition="scale-transition" max-width="280px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="$v.retention.date.$model" :error="$v.retention.date.$error" v-bind="attrs" v-on="on" outlined single-line dense readonly hide-details>
                          <template v-slot:append>
                            <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="$v.retention.date.$model" no-title @input="menu = false" type="date" locale="es-cl" width="280" color="blue">
                        <div class="mx-auto">
                        <v-btn color="primary" @click="() => { $v.retention.date.$model = today }">Hoy</v-btn>
                        <v-btn class="ml-2" outlined @click="() => {$v.retention.date.$model = ''}">Limpiar</v-btn>
                        </div>
                      </v-date-picker>
                    </v-menu>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <!-- supplier detail -->
          <v-row v-if="retention.supplier.id">
            <v-col md="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>
                    <span class="text--secondary pb-3 subtitle-1 font-weight-medium" style="width: 200px">{{retention.supplier.name}}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <v-btn @click="modalSupplier=true" color="primary" text :ripple="false">Seleccionar otro...</v-btn>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Número fiscal</v-list-item-title>
                  <v-list-item-subtitle>{{retention.supplier.tax_id}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Dirección</v-list-item-title>
                  <v-list-item-subtitle>{{retention.supplier.address}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item v-if="retention.supplier.state.name">
                  <v-list-item-title>Estado</v-list-item-title>
                  <v-list-item-subtitle>{{retention.supplier.state.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item v-if="retention.supplier.country.name">
                  <v-list-item-title>País</v-list-item-title>
                  <v-list-item-subtitle>{{retention.supplier.country.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Email</v-list-item-title>
                  <v-list-item-subtitle>{{retention.supplier.email}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Teléfono</v-list-item-title>
                  <v-list-item-subtitle>{{retention.supplier.phone}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <!-- end supplier detail -->
          <!-- supplier empty -->
          <v-row v-else>
            <v-col cols="12" class="text-center py-5">
              <v-icon class="d-block" color="secondary" size="70">mdi-account</v-icon>
              <span class="d-block subtitle-1">Selecciona un proveedor para crear el documento</span>
              <v-btn class="my-5" @click="modalSupplier=true" outlined color="secondary"><v-icon left>mdi-plus</v-icon>Seleccionar un proveedor</v-btn>
            </v-col>
          </v-row>
          <!-- end supplier empty -->

          <v-col cols="12" class="px-0">
            <!-- detail -->
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Productos y servicios</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th class="text-left" style="width:80px">Exento</th>
                    <th style="width:80px">Cant.</th>
                    <th  style="width:80px">Unidad</th>
                    <th class="text-right" style="width:100px">Precio</th>
                    <th class="text-right" style="width:156px">Subtotal</th>
                    <th style="width:56px"></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(d, i) in retention.lines">
                    <tr :key="d.id">
                      <td>
                        <v-text-field v-model.trim="d.name" :error="$v.retention.lines.$each[i].name.$error" background-color="transparent" solo required single-line flat dense placeholder="Escribe un nombre para el producto" maxlength="80" hide-details />
                        <v-text-field v-model.trim="d.description" :error="$v.retention.lines.$each[i].description.$error" background-color="transparent" required single-line class="mt-n4" solo flat dense placeholder="Descripción del producto" maxlength="1000" hide-details />
                      </td>
                      <td>
                        <v-switch v-model="d.exempt" :disabled="!selectedDocument.has_taxes" />
                      </td>
                      <td>
                        <v-text-field v-model.number="d.quantity" :error="$v.retention.lines.$each[i].quantity.$error" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" background-color="transparent" reverse full-width solo required single-line flat dense placeholder="0" maxlength="12" hide-details />
                      <td>
                        <v-text-field v-model.trim="d.unit_label" :error="$v.retention.lines.$each[i].unit_label.$error" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" background-color="transparent" solo required single-line flat dense placeholder="C/U" maxlength="4" hide-details />
                      </td>
                      <td>
                        <v-text-field v-model.number="d.amount" :error="$v.retention.lines.$each[i].amount.$error" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" required single-line background-color="transparent" reverse solo flat dense placeholder="0" maxlength="12" hide-details />
                      </td>
                      <td class="text-right">
                        <span class="text--secondary body-2 font-weight-medium">{{aggregations.lines[i].subtotal | number(((selectedDocument || {}).currency || {}).rounded)}} {{((selectedDocument || {}).currency || {}).id}}</span>
                      </td>
                      <td class="text-right">
                        <v-btn v-if="i >= 1 || retention.lines.length > 1" @click="retention.lines.splice(i, 1)" icon color="red"><v-icon small>mdi-close</v-icon></v-btn>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider />
            <v-row class="px-4" no-gutters>
              <v-col class="text-left">
                <v-btn @click="addRowLines" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar un producto</v-btn>
              </v-col>
            </v-row>
            <!-- end detail -->

            <!-- summary -->
            <v-row align="center" justify="end">
              <v-col cols="4">
                <v-list class="v-list-form pa-0 transparent">
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Subtotal</v-list-item-title>
                    <v-list-item-subtitle class="text-right font-weight-medium">{{aggregations.subtotal | number(((selectedDocument || {}).currency || {}).rounded)}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Descuento</v-list-item-title>
                    <v-list-item-subtitle class="text-right">
                      <v-row class="px-3" align="center" justify="end">
                        <v-col cols="3">
                          <v-select class="mr-1" v-model="retention.discount_scheme" :items="dropdown" item-text="name" item-value="value" hide-details="true" solo outlined flat dense>
                            <template v-slot:selection="{ item }"><span class="px-1 ml-1">{{item.value}}</span></template>
                          </v-select>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model.number="$v.retention.discount.$model" :error="$v.retention.discount.$error" oninput="this.value=this.value.replace(/[^0-9]/g,'');" background-color="white" reverse outlined required single-line dense maxlength="20" placeholder="0" hide-details/>
                        </v-col>
                      </v-row>
                      <span v-if="aggregations.discount && retention.discount_scheme === '%'">{{aggregations.discount | number}}</span>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <div class="mr-4 mt-3" v-if="!$v.retention.discount.maxAmount || !$v.retention.discount.maxPercent">
                    <div class="text-right">
                      <span class="red--text" v-if="!$v.retention.discount.maxAmount">El descuento no puede superar el subtotal</span>
                      <span class="red--text" v-if="!$v.retention.discount.maxPercent">El descuento no puede superar el 100%</span>
                    </div>
                  </div>
                  <template v-if="selectedDocument.has_taxes_detail">
                    <v-divider class="ml-4 my-3" />
                    <v-list-item class="py-1">
                      <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Exento</v-list-item-title>
                      <v-list-item-subtitle class="text-right" :class="{'red--text': aggregations.exempt < 0}">{{aggregations.exempt | number(((selectedDocument || {}).currency || {}).rounded)}}</v-list-item-subtitle>
                    </v-list-item>
                    <template v-if="selectedDocument.has_taxes">
                      <v-list-item class="py-1">
                        <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Neto</v-list-item-title>
                        <v-list-item-subtitle class="text-right" :class="{'red--text': aggregations.amount < 0}">{{aggregations.amount | number(((selectedDocument || {}).currency || {}).rounded)}}</v-list-item-subtitle>
                      </v-list-item>
                      <v-divider class="ml-4 my-3" />
                      <v-list-item>
                        <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Impuestos ({{selectedDocument.tax}}%)</v-list-item-title>
                        <v-list-item-subtitle class="text-right" :class="{'red--text': aggregations.total < 0}">{{aggregations.taxes | number(((selectedDocument || {}).currency || {}).rounded)}}</v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Retención ({{selectedDocument.tax}}%)</v-list-item-title>
                        <v-list-item-subtitle class="text-right" :class="{'red--text': aggregations.total < 0}">{{aggregations.taxes | number(((selectedDocument || {}).currency || {}).rounded)}}</v-list-item-subtitle>
                      </v-list-item>
                    </template>
                  </template>
                  <v-divider class="ml-4 my-3" />
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-left body-1 text--secondary font-weight-medium">Total</v-list-item-title>
                    <v-list-item-subtitle class="text-right body-1 text--secondary font-weight-medium" :class="{'red--text': aggregations.total < 0}">{{aggregations.total | number(((selectedDocument || {}).currency || {}).rounded)}} {{((selectedDocument || {}).currency || {}).id}}</v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <!-- end summary -->
          </v-col>

        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <template v-if="retention.id">
            <span class="body-2 mr-1">Borrador guardado</span>
            <span class="body-2 text--secondary font-weight-medium">{{retention.updated | dateFromNow}}</span>
            <v-btn @click="removeRetention" :disabled="!retention.id" text color="primary"><v-icon class="mx-1" small>mdi-delete</v-icon>Eliminar borrador</v-btn>
          </template>
          <v-spacer />
          <v-btn @click="active = true; patchRetention();" :loading="loadingSaveRetention" :disabled="!retention.id" outlined>Guardar y salir</v-btn>
          <v-btn @click="finalizeRetention" :disabled="!retention.id" :loading="isAutoSaving ? false : (loadingFinalizeRetention || $store.state.purchases.retrieveLoader)" color="primary">Crear documento</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <!-- modal supplier -->
    <v-dialog v-model="modalSupplier" width="700" persistent no-click-animation>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un proveedor</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn icon retain-focus-on-click :ripple="false" small @click="modalSupplier=false"><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="text-left">
              <v-col class="py-2">
                <v-text-field v-model="supplierQuery" background-color="white" outlined required single-line dense placeholder="Escribe para buscar un provedor..." hide-details />
              </v-col>
              <v-divider/>
              <v-skeleton-loader v-if="$store.state.suppliers.retrieveLoader" transition="fade-transition" type="list-item" />
              <template v-else>
                <template v-if="suppliersList.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in suppliersList" :key="d.id" @click="setSupplier(d)" style="cursor: pointer">
                          <td>
                            <span class="body-1 text--secondary font-weight-medium">{{d.name}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col v-else class="text-center py-5">
                  <v-icon color="secondary" size="70">mdi-close-circle</v-icon>
                  <span class="d-block subtitle-1">No existen proveedores</span>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end modal supplier -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength, numeric, decimal } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import moment from 'moment'
export default {
  mixins: [
    GenericViewMixin
  ],
  inject: ['theme'],
  components: {
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    date: moment().format("YYYY-MM-DD"),
    modalDelete: false,
    menu: false,
    loadingSaveRetention: false,
    loadingFinalizeRetention: false,
    dropdown: [
      { name: '% - Porcentaje', value: '%' },
      { name: '- Monto', value: '$'}
    ],
    isAutoSaving: false,
    active: false,
    retention: {
      supplier: {},
      document: 'CL46',
      number: 0,
      date: '',
      discount: null,
      discount_scheme: '%',
      lines: [
        {
          name: '',
          exempt: false,
          unit_label: '',
          amount: null,
          quantity: 1,
          discount: null,
          discount_scheme: '%',
          tax: null,
          tax_percent: null
        }
      ]
    },
    aggregations: {
      lines: [
        {
          subtotal: 0
        }
      ],
      amount: 0,
      exempt: 0,
      subtotal: 0,
      discount: 0,
      taxes: 0,
      total: 0
    },
    supplierQuery: '',
    sourcesDetail: {},
    retentionClone: {},
    upgradeable: false,
    modalSupplier: false,
    documentsListSelect: []
  }),
  computed: {
    aggregationsSource () {
      return {
        lines: this.retention.lines.map(line => {
          return {
            exempt: line.exempt,
            amount: line.amount,
            quantity: line.quantity
          }
        }),
        discount_scheme: this.retention.discount_scheme,
        discount: this.retention.discount
      }
    },
    selectedDocument () {
      /* Return selected retention document object */
      return this.documentsList.find(
        documents => documents.id === this.retention.document
      ) || {}
    },
    ...mapState({
      accountsDetail: state => state.auth.account,
      documentsList: state => state.generals.documentsList,
      retentionsDetail: state => state.purchases.retentionsDetail,
      suppliersList: state => state.suppliers.suppliersList
    })
  },
  created () {
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/documents',
      query: {
        country__id__in: `${this.account.country.id}, US`,
        is_purchase: 'True',
        is_sale: 'False'
      }
    })

    if (this.$route.name === 'RetentionCreate') {
      this.retention.date = this.today
    }

    if (this.$route.name === 'RetentionUpdate') {
      this.$store.dispatch('purchases/RETRIEVE', {
        resource: 'retentions',
        id: this.$route.params.id
      })
      .then((response) => {
        if (this.retentionsDetail.status === 'draft') {
          const data = cloneDeep(response.data)
          data.document = data.document.id
          this.retention = data
        } else {
          this.$router.push({
            name: 'RetentionRetrieve',
            params: {
              id: this.retentionsDetail.id
            }
          })
        }
      })
    }
  },
  watch: {
    supplierQuery () {
      this.debounceMethod(this.getSuppliers)
    },
    modalSupplier () {
      if (this.modalSupplier) {
        this.getSuppliers()
      }
    },
    retention: {
      handler: debounce(function () {
        this.retentionClone = cloneDeep(this.retention)

        if (this.$route.name === 'RetentionUpdate') {
          this.isAutoSaving = true
          this.patchRetention('retentionClone')
        } else {
          this.postRetention()
        }

        this.upgradeable = true
      }, 700),
      deep: true
    },
    aggregationsSource: {
      handler () {
        this.setAggregations()
      },
      deep: true
    },
    selectedDocument (newSelection, oldSelection) {
      const setExemptLines = (val) => {
        this.retention.lines.forEach((line, index) => {
          this.retention.lines[index].exempt = val
        })
      }
      if (this.selectedDocument.has_taxes && !oldSelection.has_taxes) {
        setExemptLines(false)
      } else if (!this.selectedDocument.has_taxes && oldSelection.has_taxes) {
        setExemptLines(true)
      }
      this.setAggregations()
    }
  },
  methods: {
    postRetention () {
      const payload = cloneDeep(this.retention)
      payload.supplier = this.retention.supplier.id

      this.$v.retentionClone.$touch()

      if (this.$v.retentionClone.$invalid) {
        return false
      }

      this.loadingFinalizeRetention = true
      this.$store.dispatch('purchases/CREATE', {
        resource: 'retentions',
        payload: payload
      })
      .then((response) => {
        this.retention = cloneDeep(response.data)
        this.retention.document = this.retention.document.id
        this.$router.replace(`/integrations/billers/built_in/retentions/${this.retention.id}/edit`)
      })
      .finally(() => {
        this.loadingFinalizeRetention = false
      })
    },
    patchRetention (validate = 'retention') {
      if (!this.upgradeable) {
        return false
      }

      const payload = cloneDeep(this.retention)
      delete payload.subtotal
      delete payload.amount
      delete payload.exempt
      delete payload.tax
      delete payload.tax_percent
      delete payload.total

      payload.supplier = this.retention.supplier.id
      this.loadingSaveRetention = true

      this.$v[validate].$touch()
      if (this.$v[validate].$invalid) {
        return false
      }

      this.$store.dispatch('purchases/UPDATE', {
        resource: 'retentions',
        id: this.retention.id,
        payload: payload
      })
      .then(() => {
        if (this.active) {
          this.$dialog.message.info('La factura se ha guardado con éxito')
          this.$router.push({ name: 'RetentionList' })
        }
      })
      .finally(() => {
        this.isAutoSaving = false
        this.loadingSaveRetention = false
      })
    },
    finalizeRetention () {
      this.$v.retention.$touch()

      if (this.$v.retention.$invalid) {
        return false
      }

      this.$dialog.warning({
        title: 'Confirmar documento',
        text: `
          <span class="d-block mb-4">Al confirmar este documento, se:</span>
          <span class="d-block pl-6">1. Validará con la agencia fiscal de ${this.account.country.name}</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'primary',
            text: 'Continuar',
            handle: () => {
              this.isAutoSaving = false
              this.loadingFinalizeRetention = true

              this.$store.dispatch('purchases/RETRIEVE', {
                resource: 'retentions',
                detail: 'finalize',
                id: this.retention.id,
                loader: false
              })
              .then(() => {
                this.$router.push({
                  name: 'RetentionRetrieve',
                  params: {
                    id: this.retentionsDetail.id
                  }
                })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
              .finally(() => {
                this.loadingFinalizeRetention = false
              })
            }
          }
        ]
      })
    },
    removeRetention () {
      if (!this.retention.status === 'draft') {
        return false
      }

      this.$dialog.warning({
        title: 'Eliminar documento',
        text: `
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('purchases/DESTROY', {
                resource: 'retentions',
                id: this.retention.id
              })
              .then(() => {
                this.$router.push({ name: 'RetentionList' })
              })
              .catch(() => {
                this.$dialog.message.error()
              })
            }
          }
        ]
      })
    },
    getSuppliers () {
      if ([1, 2].includes(this.supplierQuery.length)) {
        return false
      }

      const query = {
        page_size: 10
      }

      if (this.supplierQuery.length >= 3) {
        query.name__icontains = this.supplierQuery.toLowerCase()
      }

      this.$store.dispatch('suppliers/LIST', {
        resource: 'suppliers',
        query: query
      })
    },
    setSupplier (supplier) {
      this.retention.supplier = supplier
      this.supplierQuery = ''
      this.modalSupplier = false
    },
    addRowLines () {
      this.retention.lines.push({
        name: '',
        exempt: !this.selectedDocument.has_taxes,
        unit_label: '',
        amount: null,
        quantity: 1,
        discount: null,
        discount_scheme: '%',
        tax: null,
        tax_percent: null
      })
    },
    setAggregations () {
      const round = ((this.selectedDocument || {}).currency || {}).rounded
      let exempt = 0
      let amount = 0
      this.retention.lines.forEach((line, i) => {
        this.aggregations.lines[i] = {
          subtotal: this.formatNumber((line.amount || 0) * (line.quantity || 0), round)
        }
        if (line.exempt || !this.selectedDocument.has_taxes) {
          exempt += this.formatNumber(this.aggregations.lines[i].subtotal, round)
        } else {
          amount += this.formatNumber(this.aggregations.lines[i].subtotal, round)
        }
      })
      this.aggregations.exempt = this.formatNumber(exempt, round)
      this.aggregations.amount = this.formatNumber(amount, round)
      this.aggregations.subtotal = exempt + amount
      // discount
      if (this.retention.discount) {
        if (this.retention.discount_scheme === '%') {
          const percent = this.retention.discount / 100
          this.aggregations.amount -= this.formatNumber(this.aggregations.amount * percent, round)
          this.aggregations.exempt -= this.formatNumber(this.aggregations.exempt * percent, round)
        } else if (this.retention.discount_scheme === '$') {
          const amountPercent = this.aggregations.amount * 100 / this.aggregations.subtotal
          const exemptPercent = this.aggregations.exempt * 100 / this.aggregations.subtotal
          this.aggregations.amount -= this.formatNumber(this.retention.discount * amountPercent / 100, round)
          this.aggregations.exempt -= this.formatNumber(this.retention.discount * exemptPercent / 100, round)
        }
      }
      // taxes
      this.aggregations.taxes = this.formatNumber(this.selectedDocument.has_taxes_detail ? (this.aggregations.amount * (this.selectedDocument.tax / 100)) : 0, round)
      // total
      this.aggregations.total = this.selectedDocument.hold_taxes ? this.formatNumber(this.aggregations.exempt + this.aggregations.amount, round) : this.formatNumber(this.aggregations.exempt + this.aggregations.amount + this.aggregations.taxes, round)
    }
  },
  validations () {
    const retention = {
      document: {
        required
      },
      date: {
        required
      },
      discount: {
        numeric,
        maxAmount: function () {
          if (this.retention.discount_scheme === '$') {
            return this.retention.discount <= this.aggregations.subtotal
          }
          return true
        },
        maxPercent: function () {
          if (this.retention.discount_scheme === '%') {
            return this.retention.discount <= 100
          }
          return true
        }
      },
      lines: {
        $each: {
          name: {
            required,
            maxLength: maxLength(128)
          },
          description: {
            maxLength: maxLength(512)
          },
          unit_label: {
            maxLength: maxLength(4)
          },
          quantity: {
            required,
            decimal
          },
          amount: {
            required,
            decimal
          },
          discount: {
            numeric
          }
        }
      }
    }
    return {
      retention: retention,
      retentionClone: cloneDeep(retention)
    }
  }
}
</script>